// extracted by mini-css-extract-plugin
export default {"rootStyles":"hrbzfT","root":"JVi7i2","border":"d3n4V3"};